import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";

import "./style.css";

export interface AutocompleteListProps {
  options: Array<{ label: string; value: string }>;
  label: string;
  id: string;
  value: string;
  onChange: (e: any) => void;
  isRequired?: boolean;
  errorMsg?: string;
}

const AutocompleteList = (props: AutocompleteListProps) => (
  <div className="w-full px-4" data-track="autocomplete-container">
    <div className="mb-2 flex justify-between items-center">
      <span>
        <span
          className={`font-bold ${props.errorMsg ? "text-primary-red" : "text-grey-scale-slate"}`}
        >
          {props.label}
        </span>
        {props.isRequired && (
          <span className="font-bold text-accent-berry">*</span>
        )}
      </span>
      {props.errorMsg && (
        <span
          className="text-primary-red text-sm italic"
          data-track="autocomplete-error"
        >
          {props.errorMsg}
        </span>
      )}
    </div>
    <Autocomplete
      data-testid="autocomplete-list"
      className={`autocomplete-list ${props.errorMsg ? "error" : ""}`}
      id={props.id}
      value={
        props.options.find((option) => option.value === props.value) || null
      }
      options={props.options}
      onChange={(event, newValue) => props.onChange(newValue)}
      renderInput={(params) => (
        <TextField
          aria-describedby={props.label}
          data-testid="autocomplete-list-input"
          className="field"
          data-track="autocomplete-input"
          {...params}
        />
      )}
    />
  </div>
);

export default AutocompleteList;
